export default "__VITE_ASSET__CX7c5$47__"